/* eslint-disable no-param-reassign */
import { components } from "react-select";
import PropTypes from "prop-types";

const IndicatorSeparator = ({ className, preserveStyle, children, ...otherProps }) => {
  if (!preserveStyle) {
    // So that the default styles aren't applied, for full customization
    otherProps.getStyles = () => ({});
  }

  return (
    <components.IndicatorSeparator {...otherProps} className={className}>
      {children}
    </components.IndicatorSeparator>
  );
};

IndicatorSeparator.propTypes = {
  className: PropTypes.string,
  preserveStyle: PropTypes.bool,
  children: PropTypes.node,
};

IndicatorSeparator.defaultProps = {
  className: "",
  preserveStyle: false,
  children: null,
};

export default IndicatorSeparator;
